import React from "react";
import { Box } from "@mui/material";
import UserMenu from "./UserMenu";

const CoreMenu: React.FC = () => {
    return (
        <>
            <Box sx={{
                position: 'fixed',
                zIndex: 12,
                top: 0,
                left: 0,
                right: 0,
                height: 45,
                backgroundColor: 'primary.main',
                borderBottom: '1px solid #ddd',
                padding: '8px 16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
            >
                <Box display="flex" alignItems="center">
                    <img
                        src="/logo.png"
                        alt="Logo"
                        style={{
                            height: 40,
                            marginRight: 5,
                            //filter: 'invert(80%)',
                        }}
                    />
                </Box>
                <UserMenu />
            </Box>
            <Box sx={{ paddingTop: '61px' }}></Box>
        </>
    );
};

export default CoreMenu;